import { ArrowUpRight } from "lucide-react";
import { GYG_URL } from "@/data/site";
import { cn } from "@/lib/utils";

// Every booking CTA routes to GetYourGuide in a new tab.
export const BookButton = ({
  label = "Book Now",
  variant = "primary",
  size = "md",
  className = "",
  withArrow = true,
  testId = "book-now-button",
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-sans font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-travertine";
  const variants = {
    primary: "bg-gold text-white hover:bg-gold-dark shadow-soft hover:shadow-lift",
    dark: "bg-charcoal text-white hover:bg-black shadow-soft",
    outline: "bg-transparent border border-charcoal text-charcoal hover:bg-charcoal hover:text-white",
    light: "bg-white text-charcoal hover:bg-gold hover:text-white border border-stone-line",
  };
  const sizes = {
    sm: "px-5 py-2 text-sm",
    md: "px-7 py-3 text-sm tracking-wide",
    lg: "px-9 py-4 text-base tracking-wide",
  };
  return (
    <a
      href={GYG_URL}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={testId}
      className={cn(base, variants[variant], sizes[size], className)}
    >
      {label}
      {withArrow && <ArrowUpRight size={16} strokeWidth={2} className="-mr-1" />}
    </a>
  );
};

export default BookButton;
